import { _get, _getAxios } from './serviceMain';

export function getRewards(groupCode: string, storeCode: string, card: string, catalogId: string) {

    const queryParams = new URLSearchParams({
        groupCode: groupCode,
        storeCode: storeCode,
        card: card,
        catalogId: catalogId
      });

    const url = '/v3/catalog/rewards';

    return _getAxios(url, "GET_REWARDS_TIME", "rewards", queryParams); //"GET_REWARDS_TIME", "rewards"
  };